/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Print_LabelInputs */

const en_cargos_print_label = /** @type {(inputs: Cargos_Print_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print Label`)
};

const es_cargos_print_label = /** @type {(inputs: Cargos_Print_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir etiqueta`)
};

/**
* | output |
* | --- |
* | "Print Label" |
*
* @param {Cargos_Print_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_print_label = /** @type {((inputs?: Cargos_Print_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Print_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_print_label(inputs)
	return es_cargos_print_label(inputs)
});